import { render, staticRenderFns } from "./tableBlockEditor.vue?vue&type=template&id=0119e66c&"
import script from "./tableBlockEditor.vue?vue&type=script&lang=js&"
export * from "./tableBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./tableBlockEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemSubtitle,VMenu,VTextField})
